import { render, staticRenderFns } from "./color-variant.vue?vue&type=template&id=170d91c1"
import script from "./color-variant.vue?vue&type=script&lang=js"
export * from "./color-variant.vue?vue&type=script&lang=js"
import style0 from "./color-variant.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports